import {IController, IFormController, IModule} from "angular";
import {Debugger} from "debug";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {RedigerEksternMøtedeltakerModell} from "../møteskjema/redigerEksternDeltakerSkjemalinje";

const debug: Debugger = require('debug')('NyttMøteVelgDeltakereSkjemaKontroller');
const css = require('./nyttMøteVelgDeltakereSkjema.scss');

export class NyttMøteVelgDeltakereSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmNyttMoeteVelgDeltakereSkjema', {
            bindings: {
                velgDeltakererModell: '<',
                visEksterne: '<?',
                visTellereTopp: '<?',
                skjema: '<'
            },
            controller: NyttMøteVelgDeltakereSkjemaKontroller.forInjisering(),
            template: require('./nyttMøteVelgDeltakereSkjema.html')
        });
    }

    static forInjisering() {
        return [
            NyttMøteVelgDeltakereSkjemaKontroller
        ]
    }

    velgDeltakererModell: VelgMøtedeltakereSkjemaModell; //settes via bindings
    visEksterne = false; //settes via bindings
    visTellereTopp = false; //settes via bindings
    skjema: IFormController; //settes via bindings

    ingenMedlemmerValgt(){
       return this.antallValgt() == 0;
    }

    alleMedlemmerValgt(){
        return this.antallValgt() == this.velgDeltakererModell?.deltakere.length
    }

    antallValgt(){
        return this.velgDeltakererModell?.deltakere.filter(deltaker => deltaker.skalDelta).length
    }

    togleAlleMedlemmer() {
        if (this.alleMedlemmerValgt())
            this.velgDeltakererModell.deltakere.forEach(deltaker => deltaker.skalDelta = false);
        else
            this.velgDeltakererModell.deltakere.forEach(deltaker => deltaker.skalDelta = true);
    }

    toggleSkalDelta(deltaker:MøtedeltakerSkjemaModell){
        deltaker.skalDelta = !deltaker.skalDelta;
        this.vedSkalDeltaEndret(deltaker);
    }

    vedSkalDeltaEndret(deltaker:MøtedeltakerSkjemaModell){
        if (deltaker.skalDelta) deltaker.skalSignereProtokoll = true;
    }

    //hjelpemetoder

}

export interface VelgMøtedeltakereSkjemaModell {
    deltakere: MøtedeltakerSkjemaModell[];
    eksterneDeltakere: RedigerEksternMøtedeltakerModell[];
}


export interface MøtedeltakerSkjemaModell {
    medlem: l.GruppeMedlemListeModell;
    skalDelta:boolean;
    skalSignereProtokoll:boolean;
}
